// /admin/v1/commerce/* — orders, refunds, SKUs, price groups, coupons.

import { get, list, post } from './client';
import type { ListResult } from './client';

export type OrderStatus = 'pending' | 'paid' | 'cancelled' | 'refunded' | 'failed';

export type OrderChannel =
  | 'wx_miniapp'
  | 'wx_h5'
  | 'dy_miniapp'
  | 'h5'
  | 'ios'
  | string;

export interface Order {
  id: string;
  out_trade_no?: string;
  user_id: string;
  app_id: number;
  sku_id?: number;
  sku_code?: string;
  package_id?: number;
  amount_cents: number;
  status: OrderStatus;
  channel: OrderChannel;
  paid_at?: string | null;
  refunded_at?: string | null;
  created_at?: string;
}

export interface ListOrdersQuery {
  q?: string;
  app_id?: number;
  status?: OrderStatus;
  channel?: OrderChannel;
  user_id?: string;
  // Cursor pagination — server returns next cursor in envelope.cursor.next.
  cursor?: string;
  limit?: number;
}

export function listOrders(q: ListOrdersQuery = {}): Promise<ListResult<Order>> {
  return list<Order>('/admin/v1/commerce/orders', q);
}

export function getOrder(id: string): Promise<Order> {
  return get<Order>(`/admin/v1/commerce/orders/${id}`);
}

export interface RefundInput {
  reason: string;
  notes?: string;
  amount_cents?: number;
}

export function refundOrder(id: string, body: RefundInput): Promise<{ refund_id: string }> {
  return post<{ refund_id: string }>(`/admin/v1/commerce/orders/${id}/refund`, body);
}

// --- SKUs / price groups (briefly used from Apps detail page) -------------

export interface PriceGroup {
  id: number;
  code: string;
  name: string;
  description?: string;
}

export function listPriceGroups(): Promise<ListResult<PriceGroup>> {
  return list<PriceGroup>('/admin/v1/commerce/price-groups');
}
